import { gql } from 'apollo-angular'

import { AUTHOR_EXTENDED_FIELDS } from './author.fragments'

export const MAGAZINE_BASIC_FIELDS = gql`
  fragment MagazineBasicFields on Magazine {
    id
    slug
    title
    language
    abbreviation
    media {
      cover {
        url
        name
      }
    }
    latest_edition {
      id
      year
      edition_version
      published_at
    }
    archived
    updatedAt
    selectionAndEssence
  }
`

export const MAGAZINE_DETAIL_FIELDS = gql`
  fragment MagazineDetailFields on Magazine {
    subtitle
    subject
    year_first_publication
    issn_digital
    issn_folio
    manual_title
    manual_description
    media {
      cover {
        url
        name
      }
      trial_issue {
        url
        name
      }
    }
    frequency
    tags {
      tag
    }
    for_whom
    preface
    pricing
    price
    price_description {
      base
      package
      ci
    }
    createdAt
  }
`

export const EDITORIAL_BOARD = gql`
  ${AUTHOR_EXTENDED_FIELDS}
  fragment EditorialBoard on Magazine {
    editorial_board {
      caseLawComposer {
        ...AuthorExtendedFields
      }
      reviewer {
        ...AuthorExtendedFields
      }
      caseLawAuthor {
        ...AuthorExtendedFields
      }
      editorialSecretary {
        ...AuthorExtendedFields
      }
      editor {
        ...AuthorExtendedFields
      }
      permanentEmployee {
        ...AuthorExtendedFields
      }
      chiefEditor {
        ...AuthorExtendedFields
      }
      thirdPartyWriter {
        ...AuthorExtendedFields
      }
    }
  }
`
